<template>
  <div>
    <b-alert v-if="statusMessage" :variant="statusVariant" show dismissible @dismissed="statusMessage = ''">
      {{ statusMessage }}
    </b-alert>

    <b-card>
      <div class="d-flex align-items-center justify-content-between mb-2">
        <b-card-title class="mb-0 d-flex align-items-center">
          <feather-icon icon="ImageIcon" size="24" class="mr-1" />
          Banners da Minha Loja
        </b-card-title>
        <b-button variant="primary" @click="abrirModal()">
          <feather-icon icon="PlusIcon" size="14" class="mr-50" />
          Novo Banner
        </b-button>
      </div>

      <b-table
        :items="banners"
        :fields="campos"
        responsive
        show-empty
        empty-text="Nenhum banner cadastrado."
      >
        <template #cell(imagem)="data">
          <img v-if="data.value" :src="data.value" alt="Banner" style="max-height: 50px; max-width: 120px;" class="rounded" />
          <span v-else class="text-muted">Sem imagem</span>
        </template>
        <template #cell(ativo)="data">
          <b-badge :variant="data.value ? 'success' : 'secondary'">
            {{ data.value ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
        <template #cell(acoes)="data">
          <b-button variant="flat-primary" size="sm" @click="abrirModal(data.item)">
            <feather-icon icon="EditIcon" size="14" />
          </b-button>
          <b-button variant="flat-danger" size="sm" @click="confirmarExclusao(data.item)">
            <feather-icon icon="TrashIcon" size="14" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <b-modal v-model="showModal" :title="editando ? 'Editar Banner' : 'Novo Banner'" size="lg" @ok="salvarBanner" ok-title="Salvar" cancel-title="Cancelar">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group label="Nome" label-for="banner-nome">
              <b-form-input id="banner-nome" v-model="bannerForm.nome" placeholder="Nome do banner" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Ordem" label-for="banner-ordem">
              <b-form-input id="banner-ordem" v-model.number="bannerForm.ordem" type="number" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Ativo">
              <b-form-checkbox v-model="bannerForm.ativo" :value="1" :unchecked-value="0" switch>
                {{ bannerForm.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Imagem (Desktop)">
              <div class="d-flex align-items-center mb-1">
                <b-form-file
                  accept="image/*"
                  placeholder="Enviar imagem..."
                  browse-text="Escolher"
                  @input="uploadBannerImage($event, 'imagem')"
                  :disabled="uploadingBanner.imagem"
                  size="sm"
                />
                <b-spinner v-if="uploadingBanner.imagem" small class="ml-1" />
              </div>
              <b-form-input v-model="bannerForm.imagem" placeholder="ou cole a URL da imagem" size="sm" />
            </b-form-group>
            <div v-if="bannerForm.imagem" class="mb-2">
              <img :src="bannerForm.imagem" alt="Preview" style="max-height: 120px; max-width: 100%;" class="border rounded" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Imagem (Mobile)">
              <div class="d-flex align-items-center mb-1">
                <b-form-file
                  accept="image/*"
                  placeholder="Enviar imagem..."
                  browse-text="Escolher"
                  @input="uploadBannerImage($event, 'imagem_mobile')"
                  :disabled="uploadingBanner.imagem_mobile"
                  size="sm"
                />
                <b-spinner v-if="uploadingBanner.imagem_mobile" small class="ml-1" />
              </div>
              <b-form-input v-model="bannerForm.imagem_mobile" placeholder="ou cole a URL (opcional)" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Link de Destino" label-for="banner-link">
              <b-form-input id="banner-link" v-model="bannerForm.link" placeholder="https:// ou /categoria/1" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BButton, BTable, BBadge, BModal, BForm, BFormGroup,
  BFormInput, BFormCheckbox, BRow, BCol, BAlert, BFormFile, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardTitle, BButton, BTable, BBadge, BModal, BForm, BFormGroup,
    BFormInput, BFormCheckbox, BRow, BCol, BAlert, BFormFile, BSpinner,
  },
  data() {
    const maxSizeEnv = Number(process.env.VUE_APP_IMAGE_MAX_SIZE_MB)
    const maxImageSizeMb = Number.isFinite(maxSizeEnv) && maxSizeEnv > 0 ? maxSizeEnv : 5

    return {
      banners: [],
      showModal: false,
      editando: false,
      editandoId: null,
      maxImageSizeMb,
      maxImageSize: maxImageSizeMb * 1024 * 1024,
      maxImageDimension: 1920,
      compressionQuality: 0.92,
      allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
      bannerForm: {
        nome: '',
        imagem: '',
        imagem_mobile: '',
        link: '',
        ordem: 0,
        ativo: 1,
      },
      campos: [
        { key: 'imagem', label: 'Imagem', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'link', label: 'Link', sortable: false },
        { key: 'ordem', label: 'Ordem', sortable: true },
        { key: 'ativo', label: 'Status', sortable: true },
        { key: 'acoes', label: 'Ações', sortable: false },
      ],
      statusMessage: '',
      statusVariant: 'success',
      uploadingBanner: { imagem: false, imagem_mobile: false },
    }
  },
  async mounted() {
    await this.carregarBanners()
  },
  methods: {
    setStatus(message, variant = 'danger') {
      this.statusMessage = message
      this.statusVariant = variant
    },
    validateImageType(file) {
      if (!this.allowedImageTypes.includes(file.type)) {
        this.setStatus('Selecione apenas imagens JPEG, PNG ou GIF.', 'warning')
        return false
      }

      return true
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)

        image.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(image)
        }

        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Não foi possível ler a imagem selecionada.'))
        }

        image.src = objectUrl
      })
    },
    canvasToFile(canvas, file, mimeType, quality) {
      return new Promise(resolve => {
        canvas.toBlob(blob => {
          if (!blob) {
            resolve(file)
            return
          }

          resolve(new File([blob], file.name, {
            type: mimeType,
            lastModified: file.lastModified,
          }))
        }, mimeType, quality)
      })
    },
    hasTransparency(context, width, height) {
      const { data } = context.getImageData(0, 0, width, height)

      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
          return true
        }
      }

      return false
    },
    async compressImage(file) {
      if (file.type === 'image/gif') {
        return file
      }

      const image = await this.loadImage(file)
      const needsResize = image.width > this.maxImageDimension || image.height > this.maxImageDimension
      const needsCompress = file.size > this.maxImageSize

      if (!needsResize && !needsCompress) {
        return file
      }

      const scale = Math.min(
        this.maxImageDimension / image.width,
        this.maxImageDimension / image.height,
        1,
      )
      const width = Math.max(1, Math.round(image.width * scale))
      const height = Math.max(1, Math.round(image.height * scale))
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, width, height)

      const isPng = file.type === 'image/png'
      const mimeType = isPng && this.hasTransparency(context, width, height)
        ? 'image/png'
        : 'image/jpeg'
      const quality = mimeType === 'image/jpeg' ? this.compressionQuality : undefined

      const compressedFile = await this.canvasToFile(canvas, file, mimeType, quality)

      if (compressedFile.size >= file.size) {
        return file
      }

      return compressedFile
    },
    async prepareImage(file) {
      if (!this.validateImageType(file)) {
        return null
      }

      const compressedFile = await this.compressImage(file)

      if (compressedFile.size > this.maxImageSize) {
        this.setStatus(
          `A imagem ainda ficou acima de ${this.maxImageSizeMb}MB após a compressão automática. Reduza a resolução ou envie uma versão menor.`,
          'warning',
        )
        return null
      }

      return compressedFile
    },
    async carregarBanners() {
      try {
        this.banners = await this.$store.dispatch('minhaLoja/fetchBanners')
      } catch (e) {
        console.error(e)
      }
    },
    abrirModal(banner) {
      if (banner) {
        this.editando = true
        this.editandoId = banner.id
        this.bannerForm = {
          nome: banner.nome || '',
          imagem: banner.imagem || '',
          imagem_mobile: banner.imagem_mobile || '',
          link: banner.link || '',
          ordem: banner.ordem || 0,
          ativo: banner.ativo,
        }
      } else {
        this.editando = false
        this.editandoId = null
        this.bannerForm = { nome: '', imagem: '', imagem_mobile: '', link: '', ordem: 0, ativo: 1 }
      }
      this.uploadingBanner = { imagem: false, imagem_mobile: false }
      this.showModal = true
    },
    async salvarBanner(evt) {
      evt.preventDefault()
      try {
        if (this.editando) {
          await this.$store.dispatch('minhaLoja/updateBanner', { id: this.editandoId, payload: this.bannerForm })
          this.statusMessage = 'Banner atualizado!'
        } else {
          await this.$store.dispatch('minhaLoja/createBanner', this.bannerForm)
          this.statusMessage = 'Banner criado!'
        }
        this.statusVariant = 'success'
        this.showModal = false
        await this.carregarBanners()
      } catch (e) {
        this.statusMessage = e.response?.data?.error || 'Erro ao salvar banner.'
        this.statusVariant = 'danger'
      }
    },
    async confirmarExclusao(banner) {
      const confirm = await this.$bvModal.msgBoxConfirm(`Excluir o banner "${banner.nome}"?`, {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'Excluir',
        cancelTitle: 'Cancelar',
      })
      if (confirm) {
        try {
          await this.$store.dispatch('minhaLoja/deleteBanner', banner.id)
          this.statusMessage = 'Banner excluído!'
          this.statusVariant = 'success'
          await this.carregarBanners()
        } catch (e) {
          this.statusMessage = 'Erro ao excluir banner.'
          this.statusVariant = 'danger'
        }
      }
    },
    async uploadBannerImage(file, field) {
      const selectedFile = Array.isArray(file) ? file[0] : file
      if (!selectedFile) return

      const preparedFile = await this.prepareImage(selectedFile)
      if (!preparedFile) return

      this.uploadingBanner[field] = true
      try {
        const url = await this.$store.dispatch('minhaLoja/uploadFile', preparedFile)
        this.bannerForm[field] = url
        this.setStatus('Imagem enviada com sucesso!', 'success')
      } catch (e) {
        this.setStatus(e.response?.data?.error || 'Erro ao enviar imagem.', 'danger')
      } finally {
        this.uploadingBanner[field] = false
      }
    },
  },
}
</script>
